const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: "#1B364F", // deepblue
        borderColor: "#A2D4F2", // lightblue
        color: "#E5E5E5", // lightgray
        minHeight: "38px"
    }),
    input: (provided) => ({
        ...provided,
        color: "#E5E5E5"
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#E5E5E5"
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "#142C41", // bluegray
        color: "#E5E5E5"
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? "#FF8303" : "#142C41",
        color: state.isFocused ? "#fff" : "#E5E5E5",
        cursor: "pointer"
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: "#FF8303"
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "#0A2540" // darkblue
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "#0A2540",
        ":hover": {
            backgroundColor: "#DB6B02", // deeporange
            color: "#fff"
        }
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#fff" // ✅ ensures white text on dark background
    })
};

export default selectStyles;